<template>
    <div class="cache-container">
        <el-row>
            <el-col>
                <el-card class="box-card noBorder">
                    <template #header>
                        <div class="card-header">
                            <span>基本信息</span>
                        </div>
                    </template>
                    <el-descriptions :column="4" border>
                        <el-descriptions-item label="Redis版本">{{ info && info.redis_version }}</el-descriptions-item>
                        <el-descriptions-item label="运行模式">{{ info && info.redis_mode }}</el-descriptions-item>
                        <el-descriptions-item label="端口">{{ info && info.tcp_port }}</el-descriptions-item>
                        <el-descriptions-item label="客户端数">{{ info && info.connected_clients }}</el-descriptions-item>
                        <el-descriptions-item label="运行时间(天)">{{ info && info.uptime_in_days }}</el-descriptions-item>
                        <el-descriptions-item label="使用内存">{{ info && info.used_memory_human }}</el-descriptions-item>
                        <el-descriptions-item label="使用CPU">{{ info && info.used_cpu_user }}</el-descriptions-item>
                        <el-descriptions-item label="内存配置">{{ info && info.total_system_memory_human }}</el-descriptions-item>
                        <el-descriptions-item label="AOF是否开启">
                            {{ info && info.aof_enabled == 1 ? '是' : '否' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="RDB是否成功">{{ info && info.rdb_last_bgsave_status }}</el-descriptions-item>
                        <el-descriptions-item label="Key数量">{{ info && info.keys }}</el-descriptions-item>
                        <el-descriptions-item label="网络入口/出口">
                            {{ info && info.total_net_input_bytes }}/{{ info && info.total_net_output_bytes }}
                        </el-descriptions-item>
                    </el-descriptions>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="12">
            <el-col :span="12">
                <el-card class="box-card noBorder">
                    <template #header>
                        <div class="card-header">
                            <span>命令统计</span>
                        </div>
                    </template>
                    <div style="width: 100%; height: 400px">
                        <CommandStatistics :sourceData="commandStats" />
                    </div>
                </el-card>
            </el-col>
            <el-col :span="12">
                <el-card class="box-card noBorder">
                    <template #header>
                        <div class="card-header">
                            <span>内存信息</span>
                        </div>
                    </template>
                    <div style="width: 100%; height: 400px">
                        <MemoryInfo :sourceData="{ value: info ? parseFloat(info.used_memory_human) : 0 }" />
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
import MemoryInfo from './components/MemoryInfo.vue'
import CommandStatistics from './components/CommandStatistics.vue'
import { getCache } from '@/api/monitor.js'

onMounted(() => {
    getCacheFun()
})

const commandStats = ref([])
const info = ref({})
const getCacheFun = () => {
    getCache().then((data) => {
        for (const key in data.command_stats) {
            commandStats.value.push({
                name: key,
                value: data.command_stats[key]
            })
        }
        info.value = data.info
    })
}
</script>
<style scoped lang="scss">
.cache-container {
    .el-row {
        margin-bottom: 20px;
    }
}
</style>
